import { Destination } from '../../../api/Inventory/Entities/InventoryMovementEntities';

type MedicalRecordNumberValue = string | number | null | undefined;
type VisitIdValue = string | number | null | undefined;

interface PatientDestination {
    destinationType: string;
    destinationId: string;
    patientVisitId: VisitIdValue;
}

interface PatientDestinationFactory {
    PharmacyPatient(medicalRecordNumber: string, patientVisitId: VisitIdValue): PatientDestination;
    ProtocolPatient(medicalRecordNumber: string, patientVisitId: VisitIdValue): PatientDestination;
}

const patientDestinations: PatientDestinationFactory = Destination;

export function normalizeMedicalRecordNumber(value: MedicalRecordNumberValue): string | null {
    const text = value == null ? '' : `${value}`.trim();
    return text === '' ? null : text;
}

export function isVisitIdentified(visitId: VisitIdValue): boolean {
    return Number(visitId) > 0;
}

export function buildPharmacyPatientDestination(
    medicalRecordNumber: MedicalRecordNumberValue, visitId: VisitIdValue): PatientDestination | null {
    const record = normalizeMedicalRecordNumber(medicalRecordNumber);
    if (record == null) return null;

    return patientDestinations.PharmacyPatient(record, visitId ?? null);
}

export function buildProtocolPatientDestination(
    medicalRecordNumber: MedicalRecordNumberValue, visitId: VisitIdValue): PatientDestination | null {
    const record = normalizeMedicalRecordNumber(medicalRecordNumber);
    if (record == null || !isVisitIdentified(visitId)) return null;

    return patientDestinations.ProtocolPatient(record, visitId);
}
